import * as React from 'react'
import type {SVGProps} from 'react'
const SvgOhReturnIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={20}
        fill="currentColor"
        viewBox="0 0 16 20"
        {...props}
    >
        <path
            fillRule="evenodd"
            d="M7.9 20C4 20 .6 17 .1 13c0-.3-.1-.7-.1-1.2s.3-.9.8-.9.9.4.9.9c.1 2 .7 3.6 2.1 4.7 1.2 1.1 2.6 1.7 4 1.7.7 0 1.4-.1 2.2-.4 2.2-.8 3.6-2.5 4-5 .3-1.9-.2-3.7-1.4-5.1C11.5 6.3 9.8 5.5 8 5.5H3.5v.2c-.1.2-.1.2.8 1.1l.7.7c.2.3.3.6.2.9 0 .3-.2.6-.5.6h-.3c-.2.1-.4 0-.6-.2C2.6 7.6 1.4 6.4.3 5.2c-.4-.4-.4-.9 0-1.3C1.5 2.7 2.6 1.5 3.8.3q.3-.3.6-.3c.2 0 .5.1.6.3.3.3.3.9 0 1.3-.1.1-.5.5-.9.8-.8.7-1 .8-.9 1l.1.2h4.8c3.9.1 7.2 3.2 7.7 7.2.5 4.4-2.4 8.4-6.7 9.1-.4.1-.8.1-1.2.1"
            clipRule="evenodd"
        />
    </svg>
)
export default SvgOhReturnIcon
